/* Header types */
type HeaderType = {
  headerType?: HeaderTypeEnum;
};

export type HeaderTextType = {
  text: string;
};

export type HeaderLogoType = {
  altText: string;
  url: string;
};

export enum HeaderTypeEnum {
  STANDARD = 'STANDARD',
  PREMIUM = 'PREMIUM',
}

export type HeaderImagePropsType = HeaderLogoType & HeaderType;

export type HeaderTextPropsType = HeaderTextType & HeaderType;

export type HeaderPropsType = {
  headerLogoUrl: string;
  headerText: string;
};
